import { isValidPhoneNumber } from 'libphonenumber-js';
import * as Yup from 'yup';

import { isValidEmail, isValidName, isValidZipCode } from '../../../../Utils/validation';

export const validationSchema = (clientTagsRequired = false, reviewProfile = false): Yup.ObjectSchema<any> => {
  return Yup.object().shape({
    // Staff editing someone else's profile have no upload control, so they
    // could never satisfy this; only the care advisor's own profile needs it.
    profile_img: reviewProfile ? Yup.string() : Yup.string().required('Profile image is required'),
    first_name: Yup.string()
      .required('First name is required')
      .test('test-name', 'Enter Valid First Name', (value: any) => {
        if (value && !isValidName(value)) {
          return false;
        }
        return true;
      }),
    middle_name: Yup.string().test('test-name', 'Enter Valid Middle Name', (value: any) => {
      if (value && !isValidName(value)) {
        return false;
      }
      return true;
    }),
    last_name: Yup.string()
      .required('Last name is required')
      .test('test-name', 'Enter Valid Last Name', (value: any) => {
        if (value && !isValidName(value)) {
          return false;
        }
        return true;
      }),
    language: Yup.array().min(1, 'Language is required').required('Language is required'),
    email: Yup.string()
      .required('Email is required')
      .test('test-name', 'Enter Valid Email', (value: any) => {
        if (value && !isValidEmail(value)) {
          return false;
        }
        return true;
      }),
    phone_number: Yup.string()
      .required('Phone number is required')
      .test('test-name', 'Enter Valid Phone Number', (value: any) => {
        if (value && !isValidPhoneNumber(value)) {
          return false;
        }
        return true;
      }),
    biography: Yup.string().trim().required('Biography is required'),
    zip_code: Yup.string()
      .required('Zip code is required')
      .test('test-zip', 'Enter Valid Zip Code', (value: any) => {
        if (value && !isValidZipCode(value)) {
          return false;
        }
        return true;
      }),
    client_tag_ids: clientTagsRequired
      ? Yup.array()
          .transform((value, originalValue) => {
            if (Array.isArray(originalValue)) return originalValue;
            if (!originalValue || originalValue === '') return [];
            if (typeof originalValue === 'object') return [originalValue];
            return originalValue;
          })
          .min(1, 'Select at least one client tag')
          .required('Select at least one client tag')
      : Yup.array().of(Yup.string()),
  });
};
